import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// ======================= Candidate Side =======================

// Get all applications for the candidate (optionally filtered by status)
export const getMyApplications = async (token, status = '', includeArchived = false) =>
  axios.get(`${BASE_URL}/applications/my-applications`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { status, includeArchived }
  });

// Get details of a specific candidate application
export const getMyApplicationDetails = async (token, applicationId) =>
  axios.get(`${BASE_URL}/applications/${applicationId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Withdraw an application
export const withdrawMyApplication = async (token, applicationId) =>
  axios.delete(`${BASE_URL}/applications/${applicationId}/withdraw`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Export a specific application as PDF
export const exportMyApplicationPDF = async (token, applicationId) =>
  axios.get(`${BASE_URL}/applications/${applicationId}/export/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });

// ======================= Employer Side =======================

// Get all applications for a job posted by employer
export const getApplicationsForJob = async (token, jobId) =>
  axios.get(`${BASE_URL}/applications/job/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Get details of a single application for a job
export const getEmployerApplicationDetails = async (token, applicationId) =>
  axios.get(`${BASE_URL}/applications/${applicationId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Update (change) application status (accept, reject, shortlist, etc.)
export const updateApplicationStatus = async (token, applicationId, status) =>
  axios.patch(`${BASE_URL}/applications/${applicationId}/status`, { status }, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Export applications for a job as PDF or Excel
export const exportApplicationsPDF = async (token, jobId) =>
  axios.get(`${BASE_URL}/applications/job/${jobId}/export/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });

export const exportApplicationsExcel = async (token, jobId) =>
  axios.get(`${BASE_URL}/applications/job/${jobId}/export/excel`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });
